// extracted by mini-css-extract-plugin
export default {"wrapper":"wnTSU","price":"jhRv0","noPrice":"_pnZy","icon":"Yxv4Y","button":"l0MIL","download":"CKYkp"};